/**
 * Event bus for CJMS activities and component communication
 * Enables loose coupling between components via event emission
 */

export interface ActivityEvent {
  type: 'activity_completed' | 'activity_failed' | 'task_updated' | 'stage_changed';
  data: {
    activity?: string;
    stage?: string;
    timestamp?: Date;
    notes?: string;
  };
}

export interface CommissionEvent {
  type: 'commission_generated' | 'commission_updated' | 'referral_completed';
  data: {
    referralId?: string;
    commissionAmount?: number;
    timestamp?: Date;
  };
}

export type EventPayload = ActivityEvent | CommissionEvent;

/**
 * Centralized event bus for component communication
 * Components can emit events and subscribe to event types
 */
export const feedbackBus = {
  /**
   * Emit an event to all subscribers
   * @param type - Event type
   * @param data - Event data payload
   */
  emit: (type: string, data: unknown): void => {
    console.log('[feedbackBus] Event:', type, data);
    // In production, this would use a proper event emitter (e.g., EventEmitter or a pub/sub system)
    // For now, we log to console and could integrate with:
    // - Firebase Cloud Functions
    // - WebSocket server
    // - n8n webhooks
  },

  /**
   * Subscribe to event type
   * @param type - Event type to subscribe to
   * @param callback - Callback function to execute when event is emitted
   */
  on: (type: string, callback: (data: unknown) => void): void => {
    console.log('[feedbackBus] Subscribed to:', type);
    // In production, this would register a callback with an event emitter
  },

  /**
   * Unsubscribe from event type
   * @param type - Event type to unsubscribe from
   * @param callback - Callback function to remove
   */
  off: (type: string, callback: (data: unknown) => void): void => {
    console.log('[feedbackBus] Unsubscribed from:', type);
    // In production, this would unregister the callback from the event emitter
  },
};
